
import { mapGetters } from 'vuex'
import { convertToSlug } from '~/helpers/generate-slug'
export default {
  data() {
    return {
      navItems: this.$store.state.settings.contents.navItems,
      mobileTriggered: false,
      activeMenu: [],
      schoolNavBar: [
        {
          title: this.$custom$t('nav.eventListOfUs'),
          to: this.localePath('/etkinlik-listemiz'),
          sub: [],
        },
        {
          title: this.$custom$t('nav.myprofile'),
          sub: [
            {
              title: 'myProfile.editProfile',
              to: '/profilim',
              i18n: true,
              exact: true,
            },
            {
              title: 'myProfile.changePassword',
              to: '/profilim/sifremi-degistir',
              i18n: true,
            },
            ...(this.$store.state.settings.isCourses === 1
              ? [
                  {
                    title: 'myProfile.myCourses',
                    to: '/profilim/videolu-egitimlerim',
                    i18n: true,
                  },
                  {
                    title: 'myProfile.myQuizzes',
                    to: '/profilim/quizlerim',
                    i18n: true,
                  },
                ]
              : []),
            ...(this.$store.state.settings.isSeances === 1
              ? [
                  {
                    title: 'myProfile.mySeances',
                    to: '/profilim/seanslarim',
                    i18n: true,
                  },
                ]
              : []),
            ...(this.$store.state.settings.isBooks === 1
              ? [
                  {
                    title: 'myProfile.myBooks',
                    to: '/profilim/e-urunlerim',
                    i18n: true,
                  },
                ]
              : []),
            ...(this.$store.state.settings.isEvents === 1
              ? [
                  {
                    title: 'myProfile.myEvents',
                    to: '/profilim/etkinliklerim',
                    i18n: true,
                  },
                ]
              : []),
            {
              title: 'logout',
              to: '/logout',
              i18n: true,
            },
          ],
          to: "",
          authorised: true,
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      getCategories: 'categories/getCategories',
      getActiveUser: 'user/getActiveUser',
      getRedirectUrl: 'getRedirectUrl',
      getSettings: 'getSettings',
      getActiveLanguages: 'getActiveLanguages',
      getUserSubscriptions: 'user/getUserSubscriptions',
    }),
    menuNavBar() {
      if (this.getSettings.departmentId === 2) return this.schoolNavBar
      else return this.navItems
    },
  },
  watch: {
    getUserSubscriptions: {
      handler(newVal) {
        setTimeout(() => {
          this.SET_PRODUCTS_OF_NAVBAR()
          setTimeout(() => {
            this.navItems = this.$store.state.settings.contents.navItems
          }, 500);
        }, 500);
      },
      deep: true,
    },
  },

  methods: {
    convertToSlug,
    wc_hex_is_light(color) {
      const hex = color.replace('#', '')
      const c_r = parseInt(hex.substring(0, 0 + 2), 16)
      const c_g = parseInt(hex.substring(2, 2 + 2), 16)
      const c_b = parseInt(hex.substring(4, 4 + 2), 16)
      const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000
      return brightness > 155
    },
    COLOR() {
      const themeColor = this.$store.state.settings.themeColor
      if (this.wc_hex_is_light(themeColor)) return '#000'
      else return '#fff'
    },
    SET_ACTIVE_MENU_TOGGLE(index, to) {
      const p = this.activeMenu.indexOf(index)
      if (p === -1) this.activeMenu.push(index)
      else this.activeMenu.splice(p, 1)
      if (to !== '' && to !== '#') this.SET_MOBILE_TOGGLE()
    },
    SET_MOBILE_TOGGLE() {
      this.mobileTriggered = !this.mobileTriggered
    },
    SET_CATEGORIES_TO_NAVBAR(newNavItems) {
      const newNavItemsCategories = newNavItems.map((item) => {
        if (item.title === 'nav.categories') {
          return {
            ...item,
            sub: this.getCategories.map((category) => ({
              title: category.name,
              to: `/kategori/${category.id}-${this.convertToSlug(
                category.name
              )}`,
            })),
          }
        }
        return { ...item }
      })
      this.SET_SUBSCRIPTIONS_TO_NAVBAR(newNavItemsCategories)
    },
    // firmanın sahip olduğu eğitim tipleri getirilir.
    SET_PRODUCTS_OF_NAVBAR() {
      const newNavItems = this.navItems.map((item) => {
        if (item.title === 'nav.products') {
          return {
            ...item,
            sub: item.sub.filter((sub) => {
              if (
                this.$store.state.settings.isCourses === 1 &&
                sub.to === '/urunler/videolu-egitimlerim'
              )
                return sub
              else if (
                this.$store.state.settings.isSeances === 1 &&
                sub.to === '/urunler/seanslarim'
              )
                return sub
              else if (
                this.$store.state.settings.isBlog === 1 &&
                sub.to === '/urunler/bloglarim'
              )
                return sub
              else if (
                this.$store.state.settings.isBooks === 1 &&
                sub.to === '/urunler/e-urunlerim'
              )
                return sub
              else if (
                this.$store.state.settings.isEvents === 1 &&
                sub.to === '/urunler/etkinliklerim'
              )
                return sub
              return false
            }),
          }
        } else if (item.title === 'myProfile.myProfile') {
          return {
            ...item,
            sub: item.sub.filter((sub) => {
              if (
                sub.title === 'myProfile.editProfile' ||
                sub.title === 'myProfile.changePassword'
              ) {
                return sub
              }
              if (
                (this.$store.state.settings.isCourses === 1 &&
                  sub.title === 'myProfile.myCourses') ||
                (this.$store.state.settings.isCourses === 1 &&
                  sub.title === 'myProfile.myQuizzes')
              )
                return sub
              else if (
                this.$store.state.settings.isSeances === 1 &&
                sub.title === 'myProfile.mySeances'
              )
                return sub
              else if (
                this.$store.state.settings.isBooks === 1 &&
                sub.title === 'myProfile.myBooks'
              )
                return sub
              else if (
                this.$store.state.settings.isEvents === 1 &&
                sub.title === 'myProfile.myEvents'
              )
                return sub
              else if (sub.title === 'logout') return sub
              return false
            }),
          }
        }
        return { ...item }
      })
      this.SET_CONTACT_TO_NAVBAR(newNavItems)
    },
    SET_CONTACT_TO_NAVBAR(newNavItems) {
      const contactView =
        this.$store.state.settings.contents.contactView
          .map((p) => {
            try {
              const forms = JSON.parse(p.overview)
              return {
                ...p,
                forms: forms.map((form) => ({
                  ...form,
                  value: '',
                })),
                buttonText: p.degrees || this.$t('submit'),
                checked: false,
              }
            } catch (error) {
              return {}
            }
          })
          .find(
            (p) => p.language.toLowerCase() === this.$i18n.locale.toLowerCase()
          ) || null

      if (!contactView) {
        const newNavItemsContact = newNavItems.filter(
          (item) => item.title !== 'nav.contact'
        )
        return this.SET_CATEGORIES_TO_NAVBAR(newNavItemsContact)
      }
      return this.SET_CATEGORIES_TO_NAVBAR(newNavItems)
    },
    SET_SUBSCRIPTIONS_TO_NAVBAR(newNavItems) {
      const isSubscription = this.getUserSubscriptions.length > 0
      const newNavItemsCategories = newNavItems.map((item) => {
        if (item.title === 'nav.myprofile') {
          return {
            ...item,
            sub: [
              ...(isSubscription &&
                !item.sub.some((sub) => sub.to === '/profilim/aboneliklerim')
                ? [
                  {
                    title: this.$t('myProfile.mySubscription'),
                    to: '/profilim/aboneliklerim',
                  },
                ]
                : []),
              ...item.sub,
            ],
          }
        }
        return { ...item }
      })
      this.$store.commit('SET_UPDATE_NAV_ITEMS', newNavItemsCategories)
    },
  },
  created() {
    this.SET_PRODUCTS_OF_NAVBAR()
  },
}
